import React from "react";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import "./style.scss";

interface ButtonOkProps {
  title: string;
  onClick: (value: string) => void;
  inputTitle?: string;
  inputValue?: string;
  index?: number;
  step?: number;
  disabled?: boolean;
  isLarge?: boolean;
}

export const ButtonOk = ({
  title,
  onClick,
  inputTitle = "",
  inputValue = "",
  index = 0,
  step = 0,
  disabled,
  isLarge = false,
}: ButtonOkProps) => {
  return (
    <PrimaryButton
      onClick={onClick}
      className={`buttonOk buttonOk__${isLarge ? "large" : "small"}`}
      data-input={inputValue}
      data-title={inputTitle}
      data-index={index}
      data-step={step}
      disabled={disabled}
    >
      {title}
    </PrimaryButton>
  );
};
